import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Input, Select, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import paginationFunc from "../../../../helper/hooks/pagination";
import {
  selectAllLocations,
  selectMetadata,
  selectSearch,
  updatePaginationLocations,
  updateSearchLocations
} from "../store/slice";
import { getLocationsList } from "../store/thunks";
import AdminLocationsTable from "../components/AdminLocationsTable";
import clientApi from "../../clients/store/api";
import "../styles/locations.scss";

const { Search } = Input;

const breadCrumbs = [{ text: "LOCATIONS" }];

const AdminLocationsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const locationsList = useSelector(selectAllLocations);
  const metadata = useSelector(selectMetadata);
  const search = useSelector(selectSearch);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [clientFilter, setClientFilter] = useState("");
  const [clientFilterTimeout, setClientFilterTimeout] = useState(null);
  const [allClients, setAllClients] = useState([]);

  const pagination = paginationFunc(
    metadata,
    "Locations",
    updatePaginationLocations,
    dispatch
  );

  const page = metadata?.currentPage || 1;
  const pageSize = metadata?.itemsPerPage || 10;

  // Load all clients for the dropdown
  useEffect(() => {
    const loadClients = async () => {
      try {
        const response = await clientApi.getClientList({ page: 1, pageSize: 1000 });
        setAllClients(response.data?.data || []);
      } catch (error) {
        console.error("Error loading clients:", error);
      }
    };
    loadClients();
  }, []);

  useEffect(() => {
    dispatch(
      getLocationsList({
        page,
        pageSize,
        search,
        clientName: clientFilter
      })
    );
  }, [dispatch, page, pageSize, search, clientFilter]);

  const handleSearch = (value) => {
    // Clear existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set new timeout for 500ms
    const newTimeout = setTimeout(() => {
      dispatch(updateSearchLocations(value));
    }, 500);

    setSearchTimeout(newTimeout);
  };

  const handleClientFilter = (value) => {
    // Clear existing timeout
    if (clientFilterTimeout) {
      clearTimeout(clientFilterTimeout);
    }

    // Set new timeout for 500ms
    const newTimeout = setTimeout(() => {
      setClientFilter(value);
    }, 500);

    setClientFilterTimeout(newTimeout);
  };

  // Get client options from all loaded clients
  const clientOptions = allClients.map((client) => ({
    label: client.clientName,
    value: client.clientName
  }));

  const handleAddNewLocation = () => {
    history.push("/admin/locations/new");
  };

  return (
    <div className="admin-locations-list">
      <div className="locations-header">
        <div className="breadcrumbs">
          {breadCrumbs.map((crumb, index) => (
            <span key={index} className="breadcrumb-item">
              {crumb.text}
            </span>
          ))}
        </div>
        <div className="search-container">
          <Search
            placeholder="Search locations..."
            allowClear
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 300, marginRight: 16 }}
          />
          <Select
            placeholder="Filter by client..."
            allowClear
            showSearch
            onSearch={handleClientFilter}
            onSelect={setClientFilter}
            onClear={() => setClientFilter("")}
            options={clientOptions}
            style={{ width: 200, marginRight: 16 }}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNewLocation}>
            Add New Location
          </Button>
        </div>
      </div>
      <div className="admin-content">
        <AdminLocationsTable dataSource={locationsList} pagination={pagination} />
      </div>
    </div>
  );
};

export default AdminLocationsList;
